<template>
  <div class="qr_code" :class="{'isiOSX1':isiOSX}">
    <van-nav-bar
      title="商家推广"
      right-text="推广政策"
      :fixed="true"
      left-arrow
      @click-left="reBack"
      @click-right="groupRule"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <!-- <img :src="newSrc" /> -->
      <div class="content">
        <p class="title">扫码开通销巴<span>商家</span></p>
        <p class="label">- 支持销巴、微信、支付宝扫一扫 -</p>
        <div id="qrcode" class="qrcode" ref="qrcode"></div>
        <p class="tip">会员手机号{{memberInfo.member_phone}}的商家推广码</p>
        <div class="operate">
          <div class="tab" @click="imgToUrl(1)">
            <img src="../../assets/xiaobaGroup/album@2x.png" @error="defaultPro()" />
            <p>保存相册</p>
          </div>
          <div class="tab" @click="shpwPopup(1)">
            <img src="../../assets/xiaobaGroup/wechant@2x.png" @error="defaultPro()" />
            <p>微信好友</p>
          </div>
          <div class="tab" @click="shpwPopup(2)">
            <img src="../../assets/xiaobaGroup/wechant_moment@2x.png" @error="defaultPro()" />
            <p>朋友圈</p>
          </div>
        </div>
      </div>
      <div class="group_leader_info" @click="myAchievement">
        <img class="avatar" :src="memberInfo.head_url" @error="defaultAvatar()" />
        <div class="info">
          <p class="leader" :class="{'no_group': !isInGroup}"><img v-if="memberInfo.member_level==40" src="../../assets/xiaobaGroup/lever_vip@2x.png" /><img v-if="memberInfo.member_level==50 || memberInfo.member_level==20 || memberInfo.member_level==30" src="../../assets/xiaobaGroup/lever_city@2x.png" />{{memberInfo.member_phone}}</p>
          <p class="group" v-if="memberInfo.group_info && memberInfo.group_info.group_code">群级别Q{{memberInfo.group_info.group_level}} | 群代码{{memberInfo.group_info.group_code}}</p>
        </div>
        <div class="my_group">我的业绩<img src="../../assets/xiaobaGroup/more@2x.png" /></div>
      </div>
      <div class="chat" @click="chat"><img src="../../assets/xiaobaGroup/contract@2x.png" />遇到问题？联系客服</div>
    </div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '18.2rem' }"
    >
      <p class="title">请选择推广形式<img @click="closePopup" src="../../assets/xiaobaGroup/close@2x.png" /></p>
      <div class="operate">
        <div class="tab" @click="shareByUrl">
          <img src="../../assets/xiaobaGroup/type_of_url@2x.png" />
          <p>链接形式</p>
        </div>
        <div class="tab" @click="imgToUrl(2)">
          <img src="../../assets/xiaobaGroup/type_of_img@2x.png" />
          <p>图片形式</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import avatarDefault from "@/assets/common/avatar.png";
import productDefault from "@/assets/common/preload.png";
import groupCodeBg from "@/assets/xiaobaGroup/merchant_register_code_bg@2x.png";

import QRCode from 'qrcodejs2';
export default {
  data() {
    return {
      memberInfo: {},
      share_Url: "",
      code: "",
      isiOSX: false,
      newSrc: "",
      show: false,
      type: 0, //1微信   2朋友圈
      isInGroup: false,
      codeSize: document.body.clientWidth / 375 * 210,
      shareUrlPar: {}
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    var baseUrl = window.location.href.split(this.$route.path);
    this.$api.setToken(this.$route.query.token);
    this.share_Url = baseUrl[0] + "/xiaobaGroup/registerMerchant";
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$api
        .get("/member-relation/member/get/group/member/basic/info")
        .then(res => {
          res.head_url = res.head_url || avatarDefault;
          if(res.group_info && res.group_info.group_code) {
            this.isInGroup = true;
          }
          this.memberInfo = res;
          this.getCode();
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getCode() {
      this.share_Url = this.share_Url+'?shareCode='+this.memberInfo.share_code;
      this.qrcode = new QRCode('qrcode',{
        width: this.codeSize, // 设置宽度，单位像素
        height: this.codeSize, // 设置高度，单位像素
        text: this.share_Url // 设置二维码内容或跳转地址
      })
    },
    defaultAvatar() {
      var img = event.srcElement;
      img.src = avatarDefault;
      img.onerror = null; //防止闪图
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
    reBack() {
      this.$router.go(-1);
    },
    chat() {
      this.params("", "", "chat");
    },
    groupRule() {
      this.$router.push({
        path: "/xiaobaGroup/groupRule",
        query: {
          type: 2,
          from: 1,
          token: this.$route.query.token
        }
      });
    },
    myAchievement() {
      this.$router.push({
        path: "/xiaobaGroup/myAchievement",
        query: {
          memberId: this.memberInfo.member_id,
          token: this.$route.query.token
        }
      });
    },
    shpwPopup(type) {
      this.type = type;
      this.show = true;
      this.getSharePar();
    },
    closePopup() {
      this.show = false;
    },
    getSharePar() {
      //this.type 1微信  2朋友圈
      this.$api
        .get("/member-relation/member/group/get/config", {type: 1})
        .then(res => {
          if(res.shop_recommend_url_config_info) {
            this.shareUrlPar = {
              icon: res.shop_recommend_url_config_info.icon,
              title: res.shop_recommend_url_config_info.title,
              sub_title: res.shop_recommend_url_config_info.sub_title,
              url: this.share_Url,
              type: this.type
            }
          }
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    shareByUrl() {
      this.params(JSON.stringify(this.shareUrlPar), JSON.stringify(this.shareUrlPar), "shareByUrl");
    },
    shareByImg() {
      //this.type 1微信  2朋友圈
      let sharePar = {
        img: this.newSrc,
        type: this.type
      }
      this.params(JSON.stringify(sharePar), JSON.stringify(sharePar), "shareByImg");
    },
    preservation() {
      this.params(this.newSrc, this.newSrc, "preservation");
    },
    imgToUrl(index) {
      let canvas = document.createElement("canvas");
      canvas.width = 710;
      canvas.height = 920;
      let ctx = canvas.getContext("2d");
      let bg = new Image();
      bg.setAttribute("crossorigin", "anonymous");
      bg.src = groupCodeBg;
      bg.onload = () => {
        ctx.drawImage(bg, 0, 0, 710, 920);
        let cd = new Image();
        cd.setAttribute("crossorigin", "anonymous");
        let ua = navigator.userAgent.toLowerCase();
        let codeImgUrl;
        if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
            let qrcodeImg = document.querySelector(".qrcode img");
            codeImgUrl = qrcodeImg.src;
        } else if (/android/i.test(ua)) {
            let qrcodeCanvas = document.querySelector(".qrcode canvas");
            codeImgUrl = qrcodeCanvas.toDataURL();
        }
        cd.src = codeImgUrl;
        cd.onload = () => {
          ctx.save();
          ctx.drawImage(cd, 146, 239, 420, 420);
          ctx.restore();
          ctx.font = "normal 26px arial, '黑体'";
          ctx.textBaseline = "middle";
          ctx.textAlign = "center";
          var left = canvas.width / 2;
          var top = canvas.height - 196;
          ctx.fillStyle = "#333";
          let tipWord = '会员手机号'+this.memberInfo.member_phone+'的商家推广码';
          ctx.fillText(tipWord, left, top);
          this.newSrc = canvas.toDataURL();
          index==1 ? this.preservation() : this.shareByImg()
        };
      };
    }
  }
};
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang="less" scoped>
.qr_code {
  min-height: 100%;
  box-sizing: border-box;
  background: #F9591B;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #F9591B;
    overflow: hidden;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #ffffff;
      font-size: 1.6rem;
      font-weight: 400;
      // padding: 0 1.2rem;
      background: #F9591B;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 0.7rem 1.8rem 4.3rem;
    .content {
      height: auto;
      background: #ffffff;
      border-radius: 8px;
      padding: 2.8rem 2.7rem 2.1rem;
      .title {
        color: #131415;
        font-size: 2rem;
        text-align: center;
        height: 3.2rem;
        line-height: 3.2rem;
        font-weight: bold;
        span {
          color: #F9591B;
        }
      }
      .label {
        text-align: center;
        color: #999;
        font-size: 1.3rem;
        height: 2.1rem;
        line-height: 2.1rem;
        margin: 0.2rem 0 1.8rem;
      }
      .qrcode {
        width: 21rem;
        height: 21rem;
        margin-left: 3.8rem;
        background: url('../../assets/common/preload.png') center center;
        background-size: 100% 100%;
      }
      .tip {
        color: #333;
        font-size: 1.3rem;
        text-align: center;
        line-height: 2.1rem;
        margin: 1.2rem 0 2.1rem;
      }
      .operate {
        display: flex;
        justify-content: center;
        align-items: center;
        .tab {
          flex: 1;
          text-align: center;
          img {
            width: 4.2rem
          }
          p {
            color: #666; 
            font-size: 1.3rem;
            line-height: 2.1rem;
            margin-top: 0.6rem;
          }
        }
      }
    }
    .group_leader_info {
      height: 7.4rem;
      background: #ffffff;
      border-radius: 8px;
      padding: 1.8rem 1.8rem 1.5rem;
      margin: 1.5rem 0 10.8rem;
      box-sizing: border-box;
      position: relative;
      .avatar {
        float: left;
        width: 3.6rem;
        height: 3.6rem;
        border-radius: 1.8rem;
        margin: 0.1rem 0.9rem 0 0;
        display: inline-block;
      }
      .info {
        padding: 0 0.8rem 0 4.5rem;
        .leader {
          color: #333;
          font-size: 1.4rem;
          height: 2.3rem;
          line-height: 2.3rem;
          font-weight: bold;
          img {
            height: 2rem;
            margin: 0.2rem 0.4rem 0 0;
            display: inline-block;
            float: left;
          }
        }
        .no_group {
          margin-top: 0.9rem;
        }
        .group {
          color: #ccc;
          font-size: 1.2rem;
          line-height: 1.9rem;
          margin-top: 0.1rem;
        }
      }
      .my_group {
        color: #F9591B;
        font-size: 1.4rem;
        height: 2.3rem;
        line-height: 2.3rem;
        position: absolute;
        right: 1.8rem;
        top: 2.6rem;
        font-weight: bold;
        img {
          width: 1.2rem;
          display: inline-block;
          margin-top: 0.6rem;
        }
      }
    }
    .chat {
      color: rgba(255, 255, 255, .72);
      font-size: 1.3rem;
      text-align: center;
      height: 2.1rem;
      line-height: 2.1rem;
      margin-top: 2.1rem;
      img {
        width: 2rem;
        display: inline-block;
        margin-right: 0.6rem;
        vertical-align: middle;
      }
    }
  }
  .van-popup {
    padding-top: 1.7rem;
    .title {
      color: #333;
      font-size: 1.4rem;
      height: 2.3rem;
      line-height: 2.3rem;
      font-weight: bold;
      text-align: center;
      padding: 0 1.2rem;
      img {
        width: 2rem;
        display: inline-block;
        float: right;
      }
    }
    .operate {
      display: flex;
      justify-content: center;
      align-items: center;
      .tab {
        flex: 1;
        text-align: center;
        padding-top: 1.8rem;
        img {
          width: 5.3rem
        }
        p {
          color: #333; 
          font-size: 1.4rem;
          line-height: 2.3rem;
          margin-top: 0.9rem;
        }
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
</style>


